// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-assets_bullitttime-event_js-node_modules_dayjs_locale_af_js-node_modules_dayjs_locale-a8204f","node_modules_embroider_babel-loader-9_index_js_variant_name_dev_runtime_browser_optimizeForPr-41e135"], () => (__webpack_require__("./assets/bullitttime-event.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
